"use client";

import Image from "next/image";
import { Link } from "@/i18n/routing";

type LogoProps = {
    size?: number;
    className?: string;
};

export default function Logo({ size = 50, className }: LogoProps) {
    return (
        <Link href="/" className={`group flex items-center gap-3 hover:scale-105 transition-transform duration-200 ${className ?? ""}`}>
            <div className="relative">
                <Image
                    alt="LOGO"
                    src="/logo.png"
                    width={size}
                    height={size}
                    className="rounded-lg shadow-lg"
                />
                <div className="absolute inset-0 rounded-lg bg-gradient-to-tr from-brand-500/20 to-brand-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </div>
        </Link>
    );
}
